export enum JobTypes {
  CREDIT_WEEKLY_PL = 'credit_weekly_pl',
  DISCOVER = 'discover',
  SCRAPE_V2 = 'scrape_v2',
}

export enum JobStatuses {
  PENDING = 'pending',
  STARTED = 'started',
  SUCCEEDED = 'succeeded',
  FAILED = 'failed',
  CANCELLED = 'cancelled',
  CANCELLING = 'cancelling',
}

export interface Job {
  id: number;
  status: JobStatuses;
  type: JobTypes;
  params: { date: string; [key: string]: unknown };
  started: string;
  finished: string;
}

interface JobsStarted {
  type: 'jobs/started';
}

interface JobsFinished {
  type: 'jobs/finished';
  jobs?: Job[];
  error?: string;
}

export type JobsActions = JobsStarted | JobsFinished;

interface JobLogsStarted {
  type: 'jobs/logs/started';
}

interface JobLogsFinished {
  type: 'jobs/logs/finished';
  id: Job['id'];
  logs?: string;
  error?: string;
}

export type JobLogsActions = JobLogsStarted | JobLogsFinished;

interface CreateJobsStarted {
  type: 'jobs/create/started';
}

interface CreateJobsFinished {
  type: 'jobs/create/finished';
  jobs?: Job[];
  error?: string;
}

export type CreateJobsActions = CreateJobsStarted | CreateJobsFinished;

interface CancelJobsStarted {
  type: 'jobs/cancel/started';
}

interface CancelJobsFinished {
  type: 'jobs/cancel/finished';
  job?: Job;
  error?: string;
}

export type CancelJobsActions = CancelJobsStarted | CancelJobsFinished;
